{
  "signInRecovery": {
    "title": "Kirjautuminen keskeytyi",
    "processing": "Viimeistellään kirjautumista…",
    "message": "Kirjautumista ei voitu viimeistellä. Jatka kirjautumalla uudelleen.",
    "action": "Kirjaudu uudelleen",
    "starting": "Aloitetaan kirjautumista…",
    "restartFailed": "Kirjautumista ei voitu aloittaa. Tarkista, että selaimesi sallii sivuston tietojen tallentamisen, ja yritä uudelleen."
  },
  "loading": "Ladataan...",
  "save": "Tallenna",
  "cancel": "Peruuta",
  "delete": "Poista",
  "search": "Hae",
  "close": "Sulje",
  "confirm": "Vahvista",
  "yes": "Kyllä",
  "no": "Ei",
  "error": "Virhe",
  "success": "Onnistui",
  "retry": "Yritä uudelleen",
  "upload": "Lähetä",
  "download": "Lataa",
  "logout": "Kirjaudu ulos",
  "back": "Takaisin",
  "redirectingToLogin": "Ohjataan kirjautumiseen...",
  "profile": "Profiili",
  "settings": "Asetukset",
  "user": "Käyttäjä",
  "unnamedPerson": "Nimeä ei ole tallennettu",
  "language": "Kieli",
  "selectLanguage": "Valitse kieli",
  "appSwitcher": {
    "selectApp": "Valitse sovellus",
    "title": "Sovellukset",
    "description": "Vaihda Agion-sovellusten välillä",
    "tooltip": "Vaihda sovellusta",
    "admin": "Admin",
    "control": "Control",
    "app": "App",
    "analytics": "Analytics"
  },
  "adminDashboard": "Hallintapaneeli",
  "profileSettings": "Profiili ja asetukset",
  "uploadFiles": "Lataa tiedostoja",
  "uploadingFiles": "Ladataan tiedostoja...",
  "pleaseWait": "Odota hetki",
  "dropFilesHere": "Pudota tiedostot tähän",
  "dropFilesOrClick": "Pudota tiedostot tai klikkaa",
  "fileTypes": "Excel, CSV, JSON max {{size}}MB",
  "status": {
    "active": "Aktiivinen",
    "busy": "Varattu",
    "offline": "Ei verkossa",
    "pending": "Odottaa",
    "uploading": "Ladataan",
    "processing": "Käsitellään",
    "completed": "Valmis",
    "error": "Virhe",
    "uploaded": "Ladattu",
    "processed": "Käsitelty"
  },
  "roles": {
    "owner": "Omistaja",
    "admin": "Ylläpitäjä",
    "manager": "Päällikkö",
    "user": "Käyttäjä",
    "auditor": "Tarkastaja"
  },
  "you": "Sinä",
  "agent": "Agentti",
  "manager": "Päällikkö",
  "agents": {
    "system": {
      "assistant": "Agion Assistentti"
    }
  },
  "hitl": {
    "expired": "Tämä pyyntö on vanhentunut.",
    "timeout": "Vanhenee {{time}} päästä",
    "placeholder": "Kirjoita vastauksesi...",
    "governanceRule": "Hallintosääntö: {{rule}}",
    "operatorHandoff": {
      "title": "Agentti tarvitsee operaattorin apua",
      "description": "Agentti ei pysty ratkaisemaan tätä ja pyytää ihmisen apua"
    },
    "policyReview": {
      "title": "Hallintosäännön tarkistus vaaditaan",
      "description": "Hallintosääntö edellyttää ihmisen tarkistusta ennen jatkamista",
      "approve": "Hyväksy",
      "deny": "Hylkää",
      "decideElsewhere": "Tämä hyväksyntä päätetään Eskalaatioissa.",
      "openEscalations": "Päätä Eskalaatioissa"
    }
  },
  "nextShell": {
    "sidebar": "Chatin navigointi",
    "missionsNavigation": "Tehtävät",
    "expandSidebar": "Laajenna sivupalkki",
    "collapseSidebar": "Kutista sivupalkki",
    "openNavigation": "Avaa navigointi",
    "closeNavigation": "Sulje navigointi",
    "organization": "Organisaatio",
    "files": "Tiedostot",
    "running": "Käynnissä",
    "theme": {
      "currentLight": "Vaalea tila",
      "currentDark": "Tumma tila",
      "switchToLight": "Vaihda vaaleaan tilaan",
      "switchToDark": "Vaihda tummaan tilaan"
    },
    "appSwitcher": {
      "chat": "Chat",
      "switchApp": "Vaihda sovellusta",
      "currentApp": "Nykyinen sovellus",
      "open": "Avaa"
    },
    "missionsLoadError": "Missioita ei voitu ladata"
  },
  "nextFailure": {
    "hostUnknown": "Tämän mission ajanutta Edge-palvelinta ei ole kirjattu, joten sen keskustelua ei löydy.",
    "network": "Yhteys Agioniin epäonnistui. Tarkista verkkoyhteys ja yritä uudelleen.",
    "unavailable": "Palvelu ei vastaa juuri nyt. Yritä hetken kuluttua uudelleen.",
    "session": "Istuntosi on päättynyt. Kirjaudu sisään jatkaaksesi.",
    "forbidden": "Roolisi ei salli tätä.",
    "missing": "Sitä ei enää ole tai se on siirretty.",
    "refused": "Pyyntö hylättiin.",
    "unknown": "Jokin meni vikaan. Yritä uudelleen.",
    "hostOfflineNamed": "Tämän keskustelun sisältävä Edge-palvelin {{name}} on offline-tilassa. Yritä uudelleen, kun se on taas käytössä.",
    "hostOffline": "Tämän keskustelun sisältävä Edge-palvelin on offline-tilassa. Yritä uudelleen, kun se on taas käytössä."
  }
}
